// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"39404c44","239":"d337dbb1","412":"8d006125","732":"4ad35a80","977":"fe511e63"}[chunkId] + ".chunk.js";
};